import { render } from "./TEditor.vue?vue&type=template&id=523458cd"
import script from "./TEditor.vue?vue&type=script&lang=js"
export * from "./TEditor.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__